"use strict";

exports.__esModule = true;
exports.flattenMetrics = flattenMetrics;
function flattenMetrics(metrics) {
  return metrics.map(function (_ref) {
    var name = _ref.name,
      label = _ref.label,
      mergeProps = _ref.mergeProps,
      type = _ref.type;
    return Object.assign({
      section: "metrics",
      id: name,
      name: name,
      label: label,
      sanitizedFieldName: label,
      type: type
    }, mergeProps);
  });
}